import { render, staticRenderFns } from "./exhibitionDescPC.vue?vue&type=template&id=2664ef79&scoped=true"
import script from "./exhibitionDescPC.vue?vue&type=script&lang=js"
export * from "./exhibitionDescPC.vue?vue&type=script&lang=js"
import style0 from "./exhibitionDescPC.vue?vue&type=style&index=0&id=2664ef79&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664ef79",
  null
  
)

export default component.exports